import formatTimeSpan from '../formatTimeSpan';

import { Dateable, TimeSpanFormatter } from '../types';

const formatTimeSpanAbbreviated: TimeSpanFormatter = (
  endDate: Dateable,
  startDate: Dateable,
  addSuffix?: boolean
) => {
  return formatTimeSpan(endDate, startDate, addSuffix)
    .replace('year', 'yr')
    .replace('month', 'mo')
    .replace('week', 'wk')
    .replace('hour', 'hr')
    .replace('minute', 'min')
    .replace('second', 'sec');
};

export default formatTimeSpanAbbreviated;
